import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../../../utils/api/auth';
import { fetchEventsForHistory } from '../../../../../utils/api/adminApi';
import { DEFAULT_IMAGE_DATA_URI } from '../../../../../components/imageUtils';
import GlobalHeader from '../../../../../components/GlobalHeader.jsx';
import EventApprovalTable from '../../../Event/components/EventApprovalTable.jsx';
import Pagination from '../../../../../components/Pagination.jsx';
import '../css/EventsHistory.css';

const EventsHistory = () => {
  const nav = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);

  const handleLogout = () => {
    logout(nav);
  };

  useEffect(() => {
    const loadEvents = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchEventsForHistory();

        const mappedEvents = data.map((event) => {
          const eventid = event.EventID || event.eventid || event.event_id || event.id;
          const event_name = event.Name || event.name || event.event_name || 'Untitled Event';
          const location = event.Location || event.location || event.venue || 'N/A';
          const event_type = event.Type || event.type || event.event_type || 'Standard';
          // Derive status strictly from the Events.Approved boolean
          const isApproved = event.Approved === true;
          const status = isApproved ? 'Approved' : 'Rejected';
          const time = event.StartTime || event.time || event.start_time || 'N/A';
          const rawDate = event.StartDate || event.startdate || event.start_date || event.date || null;
          let formattedDate = 'N/A';

          if (rawDate) {
            try {
              const dateObj = new Date(rawDate);
              if (!Number.isNaN(dateObj.getTime())) {
                formattedDate = dateObj.toLocaleDateString('en-ZA', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                });
              }
            } catch {
              formattedDate = rawDate;
            }
          }

          return {
            eventid,
            event_name,
            status,
            location,
            event_type,
            time,
            formattedDate,
            file_url: event.coverimage || event.MainImage || event.file_url || DEFAULT_IMAGE_DATA_URI,
          };
        });

        setEvents(mappedEvents);
      } catch (err) {
        setError(err.message || 'Failed to load events');
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  const handleViewEvent = (event) => {
    if (!event?.eventid) return;
    nav('/adminvieweventrequest', { state: { eventid: event.eventid, fromEventsHistory: true } });
  };

  return (
    <div className="events-history-page">
      <GlobalHeader
        title="Events History"
        subtitle="View and manage all event requests"
        backTo="/admin"
        onLogout={handleLogout}
      />

      <main className="events-history-main">
        {loading && (
          <div className="events-history__state events-history__state--loading">
            <div className="events-history__spinner" />
            <p>Loading events...</p>
          </div>
        )}

        {!loading && error && (
          <div className="events-history__state events-history__state--error">
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && events.length === 0 && (
          <div className="events-history__state events-history__state--empty">
            <p>No events found.</p>
          </div>
        )}

        {!loading && !error && events.length > 0 && (
          <>
            <EventApprovalTable 
              events={events} 
              onViewEvent={handleViewEvent}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
            />
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(events.length / itemsPerPage)}
              totalItems={events.length}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
            />
          </>
        )}
      </main>
    </div>
  );
};

export default EventsHistory;
